import { render } from "./FolderPlus.vue?vue&type=template&id=54958048"
import script from "./FolderPlus.vue?vue&type=script&setup=true&lang=js"
export * from "./FolderPlus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Svg/FolderPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54958048"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54958048', __exports__)) {
    api.reload('54958048', __exports__)
  }
  
  module.hot.accept("./FolderPlus.vue?vue&type=template&id=54958048", () => {
    api.rerender('54958048', render)
  })

}


export default __exports__